import type { ContentItem } from '@/types/content';
import ContentCard from '@/components/base/ContentCard';
import SectionTitle from '@/components/base/SectionTitle';

interface RelatedSectionProps {
  title: string;
  items: ContentItem[];
  moreTo?: string;
}

export default function RelatedSection({ title, items, moreTo }: RelatedSectionProps) {
  if (items.length === 0) return null;
  return (
    <section className="mt-10">
      <SectionTitle title={title} icon="ri-links-line" moreTo={moreTo} />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((item) => (
          <ContentCard key={item.id} item={item} showSummary={false} />
        ))}
      </div>
    </section>
  );
}